import { CircularProgress } from '@mui/material';

import { SubmitButton } from 'components/UIComponents';

import { ReactComponent as UploadDocument } from 'assets/icons/uploadDocument.svg';

import { colors } from 'styles/globalStyles';

import { UploadButtonText } from './styledComponents';

type UploadButtonVariant = 'primary' | 'secondary';

interface UploadButtonProps {
  onClick: () => void;
  loading?: boolean;
  title: string;
  variant?: UploadButtonVariant;
}

const secondarySx = {
  '&': {
    backgroundColor: colors.white,
    color: colors.red,
    borderColor: colors.red,
  },
  '&:hover': {
    backgroundColor: colors.white,
    color: colors.hoveredRed,
    borderColor: colors.hoveredRed,
  },
  '&.Mui-disabled': {
    backgroundColor: colors.white,
    color: colors.disabledRed,
    borderColor: colors.disabledRed,
  },
  '& svg path': {
    stroke: colors.red,
    fill: colors.red,
  },
};

const UploadButton = ({ onClick, title, loading = false, variant = 'primary' }: UploadButtonProps) => {
  return (
    <SubmitButton disabled={loading} onClick={onClick} sx={variant === 'secondary' ? secondarySx : undefined}>
      {loading ? <CircularProgress color="inherit" size={16} /> : <UploadDocument />}
      <UploadButtonText>{title}</UploadButtonText>
    </SubmitButton>
  );
};

export default UploadButton;
